export const Container = {
  baseStyle: {
    maxWidth: '1440px',
    px: { base: 'xs', md: 's', lg: 'desktop.xl' },
  },
};
